import React from 'react'
import { News } from '../Data/News'
import { Link } from 'react-router-dom'
import { Zoom } from 'react-awesome-reveal'
import { Container, Icon } from 'semantic-ui-react'
import bannerPic1 from '../Pictures/banner1.jpg'

export default function NewsPage() {
  const bannerStyle = {
    backgroundImage: `url(${bannerPic1})`,
  }

  const sortedNews = [...News].sort(
    (a, b) => new Date(b.sort || 0) - new Date(a.sort || 0)
  )

  return (
    <div id='newsPage'>
      {/* Hero Banner */}
      <section className='pageHero' style={bannerStyle}>
        <div className='pageHeroOverlay'></div>
        <div className='pageHeroContent'>
          <Zoom triggerOnce>
            <span className='pageHeroBadge'>Updates & Stories</span>
            <h1 className='pageHeroHeading'>News & Announcements</h1>
            <div className='goldAccentLine' style={{ margin: '14px auto 20px auto' }}></div>
            <p className='pageHeroSubheading'>
              Stay connected with the latest reports, humanitarian projects, and official updates from Ghana Union.
            </p>
          </Zoom>
        </div>
      </section>

      {/* Magazine List Section */}
      <section className='homeSection'>
        <Container>
          <div className='magazineContainer'>
            {sortedNews.length === 0 ? (
              <div className='homeEmptyState'>
                <h3>No news articles published yet.</h3>
                <p>Check back soon for announcements and updates.</p>
              </div>
            ) : (
              <div className='magazineList'>
                {sortedNews.map(item => (
                  <article className='magazineItem' key={item.id}>
                    <Link to={`/newsdetails/${item.id}`} className='magazineItemLink'>
                      {item.image && (
                        <div className='magazineImageWrapper'>
                          <img
                            src={item.image}
                            alt={item.headline}
                            className='magazineImage'
                            loading='lazy'
                          />
                        </div>
                      )}
                      <div className='magazineContent'>
                        {item.date && (
                          <div className='magazineMeta'>
                            <span className='homeMetaTag'>
                              <Icon name='calendar alternate outline' /> {item.date}
                            </span>
                          </div>
                        )}
                        <h2 className='magazineTitle'>{item.headline}</h2>
                        {item.short && (
                          <p className='magazineExcerpt'>{item.short}</p>
                        )}
                        <span className='magazineActionLink'>
                          Read Full Story <Icon name='arrow right' />
                        </span>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            )}
          </div>
        </Container>
      </section>
    </div>
  )
}
